"use strict";
/**
 * A {@code SteeringBehavior} calculates the linear and/or angular accelerations to be applied to its owner.
 *
 * @param <T> Type of vector, either 2D or 3D, implementing the {@link Vector} interface
 *
 * @author davebaol
 */
var SteeringBehavior = (function () {
    /**
     * Creates a {@code SteeringBehavior} for the specified owner, limiter and activation flag.
     *
     * @param owner the owner of this steering behavior
     * @param limiter the limiter of this steering behavior
     * @param enabled a flag indicating whether this steering behavior is enabled or not
     */
    function SteeringBehavior(owner, limiter, enabled) {
        if (limiter === void 0) { limiter = null; }
        if (enabled === void 0) { enabled = true; }
        this.owner = owner;
        this.limiter = limiter;
        this.enabled = enabled;
    }
    /**
     * If this behavior is enabled calculates the steering acceleration and writes it to the given steering output. If it is
     * disabled the steering output is set to zero.
     * @param steering the steering acceleration to be calculated.
     * @return the calculated steering acceleration for chaining.
     */
    SteeringBehavior.prototype.calculateSteering = function (steering) {
        return this.isEnabled() ? this.calculateRealSteering(steering) : steering.setZero();
    };
    /** Returns the owner of this steering behavior. */
    SteeringBehavior.prototype.getOwner = function () {
        return this.owner;
    };
    /**
     * Sets the owner of this steering behavior.
     * @return this behavior for chaining.
     */
    SteeringBehavior.prototype.setOwner = function (owner) {
        this.owner = owner;
        return this;
    };
    /** Returns the limiter of this steering behavior. */
    SteeringBehavior.prototype.getLimiter = function () {
        return this.limiter;
    };
    /**
     * Sets the limiter of this steering behavior.
     * @return this behavior for chaining.
     */
    SteeringBehavior.prototype.setLimiter = function (limiter) {
        this.limiter = limiter;
        return this;
    };
    /** Returns true if this steering behavior is enabled; false otherwise. */
    SteeringBehavior.prototype.isEnabled = function () {
        return this.enabled;
    };
    /**
     * Sets this steering behavior on/off.
     * @return this behavior for chaining.
     */
    SteeringBehavior.prototype.setEnabled = function (enabled) {
        this.enabled = enabled;
        return this;
    };
    /** Returns the actual limiter of this steering behavior. */
    SteeringBehavior.prototype.getActualLimiter = function () {
        return this.limiter == null ? this.owner : this.limiter;
    };
    /**
     * Utility method that creates a new vector.
     * <p>
     * This method is used internally to instantiate vectors of the correct type parameter {@code T}. This technique keeps the API
     * simple and makes the API easier to use with the GWT backend because avoids the use of reflection.
     *
     * @param location the location whose position is used to create the new vector
     * @return the newly created vector
     */
    SteeringBehavior.prototype.newVector = function (location) {
        return location.getPosition().clone().setZero();
    };
    return SteeringBehavior;
}());
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = SteeringBehavior;
//# sourceMappingURL=SteeringBehavior.js.map


/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/pawsong/gdx-ai.js/lib/steer/SteeringBehavior.js
 ** module id = 117
 ** module chunks = 0
 **/